/* eslint-disable no-restricted-globals */
/* eslint-disable max-len */
/* eslint-disable no-console */
import React, { useContext, useState } from 'react';
import ReactDOM from 'react-dom';
import { RxCross2 } from 'react-icons/rx';
import { MdOutlineGif } from 'react-icons/md';
import { CgSmileMouthOpen } from 'react-icons/cg';
import EmojiPicker, { EmojiStyle } from 'emoji-picker-react';
import { VscSend } from 'react-icons/vsc';
import { Box, Avatar, Stack, TextField, useMediaQuery, Typography } from '@mui/material';
import { createEventComments, updateEventComment } from '../../../../../../actions/recognition_actions';
import { createComment, updateCommentApi } from '../../../../../../actions/feeds_actions_new';
import { useSelector } from 'react-redux';
import { catchErr, generateRandomUUID, userInfo } from '../../../../../../../libs/HelperContent';
import { commentContext } from '../..';
import { Theme } from '@mui/material/styles';
import { LanguageContext } from '../../../../../../../libs/Context';
import GifPickerWrapper from '../../../../../../../components/Common/GifPicker';
import ProfilePic from '../../../../../../../components/Common/ProfilePic';

interface Props{
    from:'events'|'feeds';
    setRepliesData:(val)=>void;
    repliesData:any[];
    comment:string;
    feedCardActn:any;
    selEvent:any;
    setLoading:(val)=>void;
    setComment:(val)=>void;
    cmntData:any;
	commntsData:any[];
	setCommntsData:(val)=>void;
}

const PostReplies = (props:Props) =>
{
	const { from, setRepliesData, repliesData, comment,
		feedCardActn, selEvent, setLoading, setComment, cmntData, commntsData, setCommntsData } = props;
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { action, setAction } = useContext(commentContext);
	const { language } = useContext(LanguageContext);
	const actionKeys = Object?.keys(action)?.length > 0 && Object?.entries(action)[0];

	const [ showPicker, setShowPicker ] = useState<string>('');

	const handleUpdateCmnt = async (emojiUrl) =>
	{
		try
		{
			setLoading(true);
			const query:any = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role

			};
			const body:any = {
				comment   : emojiUrl !== 'reply' ? emojiUrl : comment,
				commentId : from === 'events' ? actionKeys[1]?.commentId : actionKeys[1]?._id
			};

			if (from === 'events')
			{
				body.eventId = selEvent?.eventId;
			}
			else
			{
				body.feedId = feedCardActn[1]?._id;
			}

			const res = from === 'events' ? await updateEventComment(body, query) : await updateCommentApi(body, query);

			if (res?.status)
			{
				const updteIndex = repliesData?.findIndex((itemD:any) => itemD._id === actionKeys[1]?._id);

				const updatedViewData = [ ...repliesData ];

				updatedViewData[updteIndex] = { ...updatedViewData[updteIndex], comment: body?.comment };

				setRepliesData(updatedViewData);
			}
			else
			{
				setRepliesData(repliesData || []);
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
		}
		finally
		{
			setLoading(false);
			setComment('');
			setAction({});
			showPicker !== '' && setShowPicker('');
		}
	};
	const btnEle = document.getElementById('show-cmntReply-btn');

	const handleReplyCmnt = async (emojiUrl) =>
	{
		try
		{
			setLoading(true);
			const query:any = {
				uid     : userData?.userId,
				comid   : userData?.companyId,
				empRole : userData?.empRole,
				role    : userData?.role

			};

			const body:any = {
				comment          : emojiUrl !== 'reply' ? emojiUrl : comment,
				...(from !== 'events' ? { feedId: feedCardActn[1]?._id } : {}),
				refId            : generateRandomUUID(),
				replyToCommentId : actionKeys[1]?.replyToCommentId,
				replyName        : from === 'events' ? userData?.firstName : actionKeys[1]?.userData?.firstName,
				userData         : userInfo(userData)
			};

			if (from === 'events')
			{
				body.eventId = selEvent?.eventId;
			}

			const res = from === 'events' ? await createEventComments(body, query) : await createComment(body, query);

			if (res?.status)
			{
				const newComment = { ...res?.response };

				console.log('newComment', newComment, res);

				setRepliesData((prev) => [ newComment, ...prev ]);

				setCommntsData((prev) =>
					prev.map((item) => (item._id === actionKeys[1]?.replyToCommentId
						? { ...item, repliesCount: (item.repliesCount || 0) + 1 }
						: item)
					)
				);
			}
			else
			{
				setRepliesData(repliesData);
			}
		}
		catch (err)
		{
			console.log(err);
			catchErr(err);
		}
		finally
		{
			setComment('');
			setLoading(false);
			setAction({});
			showPicker !== '' && setShowPicker('');
		}
	};
	const onEmojiClick = (emojiData, event:any) =>
	{
		event.stopPropagation();
		setComment((prevInput) => prevInput + emojiData.emoji);
	};
	const handleChange = (type) =>
	{
		setShowPicker(type === showPicker ? '' : type);
	};
	const handleEmoji = (gifD) =>
	{
		actionKeys[0] === 'cmntReply' ? handleReplyCmnt(gifD?.url) : handleUpdateCmnt(gifD?.url);
	};

	const handleError = (event: any) =>
	{
		event.currentTarget.src = '/images/icons/defaultUser.svg';
	};
	const isMobileSM = useMediaQuery((theme: Theme) => theme.breakpoints.down(1370));

	return (
		<>
			{btnEle && [ 'cmntReply', 'cmntEdit' ]?.includes(actionKeys[0]) &&
			actionKeys[1]?.replyToCommentId === (from === 'events' ? cmntData?.commentId : cmntData?._id) &&
			ReactDOM.createPortal(
				<Stack direction='column' spacing={0.75} sx={{ position: 'sticky', bottom: '-7px', left: '0', background: '#fff' }}>
					<Stack direction='row' spacing={1} position='relative' alignItems='center'>
						<MdOutlineGif fontSize={26} style={{ cursor: 'pointer' }} onClick={() => handleChange('gif')}/>
						<CgSmileMouthOpen fontSize={20} style={{ cursor: 'pointer' }} onClick={() => handleChange('emoji')} color={showPicker ? '#23A4C4' : ''}/>
						<Box position='absolute' bottom={30} maxHeight='320px' left='-17px' zIndex={999} overflow='auto'>
							{showPicker === 'emoji' &&
							<EmojiPicker emojiStyle={EmojiStyle.GOOGLE}
								height={320}
								onEmojiClick={onEmojiClick}
								width={isMobileSM ? 290 : 320}
								previewConfig={{ showPreview: false }} autoFocusSearch={false}
							/>}
						</Box>
						{/* this is gif package it use api onec check becuase of  tenorApiKey={''} 
					it show error without this it not work or
					 you use another packeg that also have api  */}

						<Box position='absolute' bottom={24} width='100%' left='-8px' zIndex={999} overflow='auto'>
							{showPicker === 'gif' && (
								process.env.REACT_APP_GIF_KEY
									? (
										<GifPickerWrapper handleEmoji={handleEmoji}/>
									)
									: (
										<div>missing gif key....</div>
									)
							)}
						</Box>
					</Stack>
					<Box sx={{ background: '#E1E1E1' }} p={1} borderRadius={2}>
						<Stack direction='row' justifyContent='space-between' alignItems='center'>
							<Typography variant='caption'>{actionKeys[0] === 'cmntEdit' ? `${language?.edit} ` : `${language?.replyTo} `}
								<Typography variant='caption' component='span' fontWeight={500}>
									{`${actionKeys[1]?.userData?.firstName}'s ${language.comment}`}
								</Typography>
							</Typography>
							<RxCross2 fontSize={18} color='#000' style={{ cursor: 'pointer' }} onClick={() => setAction({})}/>
						</Stack>
					</Box>
					<Box sx={{ background: '#F0F0F3' }} p='var(--pixel12)' borderRadius={2}>
						<Stack direction='row' justifyContent='space-between'>
							<Stack direction='row' spacing={1} alignItems='center' width='100%'>
								{/* <Avatar sx={{ width: 24, height: 24, border: '1px solid #E6E4EA' }}
									onError={handleError}
									src={`${process.env.REACT_APP_S3_BASE_URL}/profile/${actionKeys[1]?.userData?.userId || actionKeys[1]?.userId}.jpeg?t=${new Date().valueOf()}`}
								/> */}
								<Box display='inline-flex'
									height={24}
									width={24}
									alignItems='center'
									justifyContent='center'
								>
									<ProfilePic
										imagePath={`${userData?.userId}.jpeg`}
										defaultImg='/images/icons/defaultUser.svg'
										// loadUrl='profile'
										alt='createdBy_img'
										className='brdrRadius50'
										from='selfProfile'
									/>
								</Box>

								<TextField
									size='small'
									fullWidth
									id='msgField'
									variant='outlined'
									value={comment}
									style={{ border: 'none' }}
									placeholder={language?.addaComment}
									onChange={(e) => setComment(e?.target?.value?.replace(/^\s+/, ''))}
									onFocus={focus}
									autoFocus
									onKeyDown={(e) =>
									{
										if (e.key === 'Enter')
										{
											e.preventDefault();
											actionKeys[0] === 'cmntReply' ? handleReplyCmnt('reply') : handleUpdateCmnt('reply');
										}
									}}
									InputProps={{
										sx : {
											'& .MuiOutlinedInput-notchedOutline' : {
												border : 'none'
											},
											'&:hover .MuiOutlinedInput-notchedOutline' : {
												border : 'none'
											},
											'&.Mui-focused .MuiOutlinedInput-notchedOutline' : {
												border : 'none'

											}
										},

										inputProps : {
											sx : {
												padding : '0 14px 0 0 '
											}
										}
									}}
								/>
							</Stack>
							<VscSend fontSize={24} color='#24A4C4' style={{ cursor: 'pointer' }}
								onClick={() => { actionKeys[0] === 'cmntReply' ? handleReplyCmnt('reply') : handleUpdateCmnt('reply'); }}
							/>
						</Stack>
					</Box>
				</Stack>, btnEle
			)}
		</>
	);
};

export default PostReplies;